import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateValidationError } from '@mui/x-date-pickers/models';
import { PaperProps, PopperProps, TextField, TextFieldProps } from '@mui/material';
import { StyledDatePicker } from './CoreDatePicker.styles';

type CalendarPickerView = 'day' | 'month' | 'year';

export interface CoreDatePickerProps {
  disabled?: boolean;
  format?: string;
  label: string;
  mask?: string;
  maxDate?: Date;
  minDate?: Date;
  onAccept?: (value: Date | null) => void;
  onChange: (value: Date | null, keyboardInputValue?: string) => void;
  onClose?: () => void;
  onError?: (error: DateValidationError, value: Date | null) => void;
  onOpen?: () => void;
  open?: boolean;
  openTo?: CalendarPickerView;
  PaperProps?: Partial<PaperProps>;
  PopperProps?: PopperProps;
  slots?: {
    textField?: typeof TextField;
  };
  slotProps?: {
    textField?: Partial<TextFieldProps>;
  };
  value?: Date | null;
  views?: CalendarPickerView[];
}

export const CoreDatePicker = ({
  disabled = false,
  format = 'MM/dd/yyyy',
  label,
  maxDate,
  minDate,
  onChange,
  slots = { textField: TextField },
  slotProps,
  value = new Date(),
  views = ['day'],
  PopperProps,
  ...rest
}: CoreDatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledDatePicker
        disabled={disabled}
        format={format}
        label={label}
        maxDate={maxDate}
        minDate={minDate}
        onChange={(value) => {
          onChange(value);
        }}
        slots={slots}
        slotProps={{
          ...slotProps,
          textField: {
            ...slotProps?.textField,
          },
          popper: PopperProps,
        }}
        value={value}
        views={views}
        {...rest}
      />
    </LocalizationProvider>
  );
};
